import React, { useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TablePagination } from '@material-ui/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { faCheckCircle, faAngleLeft, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';


import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '@material-ui/core';

import API_PATH from "../../constants/config.json";
import { useHistory } from 'react-router-dom';
import { clearCookie } from '../../functions/Auth';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  filterTable: {
    position: 'relative',
    width: '100%',
    float: 'left',
    '@media only screen and (min-width: 3501px)': {
      marginTop: '35px',
    },
    '& .MuiTableCell-head': {
      fontWeight: '600',
      fontSize: '14pt',
      background: '#fff',
      color: '#000',
      border: '1px solid #d1d1d1',
      '@media only screen and (max-width: 3500px)': {
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        padding: '10px 5px',
      },
    },
    '& .MuiCheckbox-root': {
      padding: '0px',
    },
    '& .MuiFormControl-root': {
      border: '1px solid #24618E',
      borderRadius: '3px 3px 3px 3px',
      paddingLeft: '0px',
      position: 'absolute',
      padding: '0px 6px 0px 0px',
      top: '16px',
      marginTop: '-7px',
      zIndex: 1,
      '@media only screen and (max-width: 3500px)': {
        width: '400px',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '650px',
        '& input': {
          fontSize: '24pt',
        }
      },
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#fff',
      },
      '& :hover .MuiInputAdornment-positionEnd button': {
        color: '#24618E !important',
        fontWeight: '600 !important',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInputAdornment-positionStart': {
      background: '#24618E',
      color: '#fff',
      paddingLeft: '5px',
      borderRadius: '0px 3px 3px 0px',
      position: 'relative',
      left: '100%',
      '@media only screen and (max-width: 3500px)': {
        height: '32px',
        width: '43px',
      },
      '@media only screen and (min-width: 3501px)': {
        height: '60px',
        width: '70px',
        maxHeight: '60px',
        marginLeft: '-28px',
      },
    },
    '& .MuiToolbar-root ': {
      paddingLeft: '0px',
      minHeight: '48px !important',
    },
    '& .MuiInput-root': {
      left: '-30px',
    },
    '& .MuiInputAdornment-positionStart svg': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '31px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '50px !important',
        marginLeft: '5px',
      },
    },
    '& svg': {
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt !important',
      },
    },
    '& td': {
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '12pt !important',
        padding: '7px 5px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
        padding: '10px 5px',
      },
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#f2f2f2'
    },
    '& table': {
      borderRight: '1px solid #D7D7D7',
      marginTop: '5px',
    },
    '& .MuiTableCell-head:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTableCell-body:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTablePagination-select': {
      color: '#000',
    },
  },
  successMsgDiv: {
    width: '100%',
    float: 'left',
    '& .msgCross': {
      width: '2%',
      float: 'right',
      textAlign: 'center',
      fontSize: '14pt',
      fontWeight: '600',
      cursor: 'pointer',
    },
    '& .msgText': {
      width: '98%',
      float: 'left',
    }
  },
  addNewStation: {
    position: 'absolute',
    right: '0',
    border: '1px solid #333',
    padding: '3px 25px',
    color: '#333',
    textDecoration: 'none',    
    borderRadius: '5px',
    marginRight: '6px',
    '@media only screen and (max-width: 3500px)': {
      top: '0px',
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      top: '-28px',
      fontSize: '24pt',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    },
  },
  exportStation: {
    position: 'absolute',
    right: '0',
    border: '1px solid #333',
    padding: '3px 25px',
    color: '#333',
    textDecoration: 'none',    
    borderRadius: '5px',
    marginRight: '6px',
    '@media only screen and (max-width: 3500px)': {
      top: '0px',
      fontSize: '14pt',
    },
    '@media only screen and (min-width: 3501px)': {
      top: '-28px',
      fontSize: '24pt',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    },
  },
  tdLink: {
    color: '#24618E',
    textDecoration: 'none',
  },
  crossCursor: {
    color: '#24618d',
    fontSize: '14pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '30px !important',
    right: '0px',
    cursor: 'pointer'
  },
  deleteIcon: {
    color: '#333',
    fontFamily: 'Avenir_Black',
    fontWeight: '600',
    verticalAlign: 'middle',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
    },
    "&:hover": {
      color: "#CC0000",
      cursor: 'pointer',
    }
  },
  clearBtn: {
    border: '1px solid #333',
    color: '#333',
    // fontSize: '12px',
    width: '150px',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 5px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    }
  },
  delBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',
    width: '150px',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 10px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    }
  },
  header: {
    fontWeight: '800',
    color: '#24618d',
    fontFamily: 'Avenir_Black',
    fontSize: '18pt',
  },
  errorMsg: {
    backgroundColor: "#F2DEDE",
    border: "1px solid #CC0000",
    fontFamily: 'Avenir_Black',
    fontSize: '14pt',
    padding: '5px',
    marginBottom: '15px'
    , borderRadius: '5px'
  },
  heading: {
    fontFamily: '"Avenir_light" !important',
    fontSize: '14pt',
    lineHeight: '23px',
  },
  importedMsg: {
    background: '#DFF0D8',
    margin: '0',
    padding: '5px 5px 3px 5px',
    width: '99.5%',
    float: 'left',
    border: '1px solid #006600',
    borderRadius: '4px',
    color: '#333',
    fontSize: '12pt',
    '& svg': {
      color: '#006600',
      fontSize: '18pt',
      verticalAlign: 'middle',
      marginRight: '10px',
    }
  },
  unabledMsg: {
    background: '#F2DEDE',
    margin: '0',
    padding: '5px 5px 3px 5px',
    width: '99.5%',
    float: 'left',
    border: '1px solid #CC0000',
    borderRadius: '4px',
    color: '#333',
    fontSize: '12pt',
    '& svg': {
      color: '#CC0000',
      fontSize: '18pt',
      verticalAlign: 'middle',
      marginRight: '10px',
    }
  },
  deletePopup: {
    '& .MuiDialogContent-root': {
      padding: '10px 15px',
    },
    '& .MuiPaper-root': {
      border: '1px solid #24618d',
      width: '525px',
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      paddingTop: '30px'
    }
  },
  crossIcon: {
    color: '#24618d',
    fontSize: '20pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '40px !important',
    right: '5px',
    "&:hover": {
      // color: "#CC0000",
      cursor: 'pointer',
    }
  },
  infoErrorIcon: {
    color: '#CC0000',
    fontSize: '25px',
    position: 'relative',
    top: '4px',
    marginRight: '10px',
  }
}));
//End Css Code ...

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


//Start Stations component code ...
const Stations = props => {
  let history = useHistory();
  const [stationList, setStationList] = React.useState([]);
  const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);
  const [hover, setHower] = React.useState(false);
  const [getSearchTerm, setSearchTerm] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [myFileID, setMyFileId] = React.useState();
  const [stationID, setStationId] = React.useState();
  const [getFileName, setFileName] = React.useState();
  const [getLoader, setLoaderDisable] = React.useState(false);
  const [successMsg, setSuccessMsg] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);

  const refContainer = useRef('');
  let enteriesPerPage = 25;
  let values = {
    "pageNo": pagination.selectedPage,
    "entriesPerPage": enteriesPerPage,
  }

  useEffect(
    () => {
      getStationsAPI();
    }, [props.stationId]
  )
  const classes = useStyles();

  const handleClickOpen = (client_station_id, station_location, station_id) => {
    setSuccessMsg(false);
    setErrorMsg(false);
    setMyFileId(client_station_id);
    setFileName(station_location);
    setStationId(station_id)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // let pages = stationList.length > 25 ? true : false;

  const getStationsAPI = (page = 1, search = "", enable = false) => { // API call to get all teams
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        data: {

          pageNo: page,
          entriesPerPage: enteriesPerPage,
          searchEnable: enable,
          searchValue: search
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.getAllStationsAPI,
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            try {
              setLoaderDisable(false);
              setStationList(response.data.data.rows);
              setTotalItems(response.data.data.count);
            } catch (error) {
              setLoaderDisable(false);
              setStationList([]);
              setTotalItems([]);
            }

          } else {
            setLoaderDisable(false);
            setStationList([]);
          }

        })
        .catch(async function (error) {
          if (error.response) {
            if (error.response.status && error.response.status == '401') {
              if (Cookies.get('email')) {
                clearCookie('email');
                clearCookie('payload');
                clearCookie('idToken');
                clearCookie('organization');
                clearCookie('atexpiry');
              }
              history.push('/');
            } else if (error.response.data && error.response.data.status && error.response.data.status == 403) {
              setUserAccess(false);
              setStationList([]);
              setLoaderDisable(false);
            } else {
              setStationList([]);
              setLoaderDisable(false);
            }
          } else {
            setStationList([]);
            setLoaderDisable(false);
          }
        })
    } catch (error) {
      console.error(error);
      setLoaderDisable(false);
    }
  }
  // This method is use for API call to get all stations .... end

 
  const handleSelected = (e, selectedPage) => {
    if (getSearchTerm != '') {
      let page = selectedPage + 1;
      values.pageNo = selectedPage + 1;
      setPagnation({ selectedPage: selectedPage + 1 })
      getStationsAPI(page, getSearchTerm, true)
    } else {
      let page = selectedPage + 1;
      values.pageNo = selectedPage + 1;
      setPagnation({ selectedPage: selectedPage + 1 })
      getStationsAPI(page);
    }
  }



  const searchField = (e) => {
    setHower(true)   
    setSearchTerm(e.target.value);
    getStationsAPI(1, e.target.value, true)
    setPagnation({ selectedPage: 1 })
  }

  const onSearch = () => {
    getStationsAPI(1, getSearchTerm, true)
    setPagnation({ selectedPage: 1 })
  }

  const rejectFile = () => {
    try {
      axios({
        method: 'delete',
        url: API_URL + API_PATH.deleteStations + '/' + stationID,
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            // getFileList(props.stationId);
            getStationsAPI();
            setSuccessMsg(true);
          }
           if (response.status && response.status == '204'){
            getStationsAPI();
            setErrorMsg(true);
          }
        })
        .catch(function (error) {
          console.log(error)
          setSuccessMsg(false);
          setErrorMsg(false);
        })
    } catch (error) {
      console.error(error);
      setSuccessMsg(false);
      setErrorMsg(false);
    }
    setOpen(false);
  }

  const clearText = () => {
    refContainer.current.reset();
    setSearchTerm('');
    getStationsAPI();
  }

  const hideSuccessMsg = () => {
    setSuccessMsg(false);
    setErrorMsg(false);
  }

  return (
    <>
      {successMsg ?
        <div className={classes.successMsgDiv}><p className={classes.importedMsg}><span className='msgText'><FontAwesomeIcon icon={faCheckCircle} />The station has successfully been deleted.</span><span className='msgCross' onClick={hideSuccessMsg}>x</span></p></div>
        : null}
        {errorMsg ?
        <div className={classes.successMsgDiv}><p className={classes.unabledMsg}><span className='msgText'><FontAwesomeIcon icon={faExclamationCircle} />Unable to delete a station that contains data.</span><span className='msgCross' onClick={hideSuccessMsg}>x</span></p></div>
        : null}
       
      <div className={classes.filterTable} data-testid='all_stations_table'>
        <form ref={refContainer} noValidate autoComplete="off">
          <TextField
            id="input-with-icon-textfield"
            placeholder="Search"
            onChange={(e) => searchField(e)}
            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" onClick={onSearch}>
                  <SearchIcon style={{ cursor: 'pointer' }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  {hover && <FontAwesomeIcon icon={faTimes} className={classes.crossCursor} onClick={clearText} />}
                </InputAdornment>
              ),
            }}

          />
        </form>

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.deletePopup}
        >
          <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
            <Typography component={"h4"} className={classes.header} style={{ marginLeft: "-20px" }}>
              Delete Station
          <FontAwesomeIcon icon={faTimes} className={classes.crossIcon} onClick={handleClose} />
            </Typography>
          </DialogTitle>

          <DialogContent>

            <Typography className={classes.errorMsg} >
              <FontAwesomeIcon icon={faExclamationCircle} className={classes.infoErrorIcon} />This action will permanently delete this station
          </Typography>

            <Typography gutterBottom className={classes.heading}>
              Proceeding with this action will permanently delete the following station from DataPoint:
          </Typography>
            <Typography gutterBottom className={classes.heading} style={{ marginTop: '20px', wordBreak: 'break-all' }}>
              {myFileID + ' - ' + getFileName}
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} className={classes.clearBtn} autoFocus={true} style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
              Cancel </Button>
            <Button onClick={() => rejectFile()} className={classes.delBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginRight: "10px", marginBottom: "10px" }}>
              Delete
 </Button>
          </DialogActions>
        </Dialog>

        {/* Error Dialogue Box */}

        <MaterialTable
          icons={tableIcons}
          title={
            userAccess == true ? 
            <>
              <NavLink to="#" className={classes.addNewStation} onClick={props.tabStationValue}>Add New Station</NavLink>
              {/* <NavLink to="#" className={classes.exportStation} onClick={props.tabExportTab}>Export</NavLink> */}
            </>
            : null}
          columns={[
            {
              title: 'Station ID', field: 'client_station_id', cellStyle: {
                width: '10%',
              },
              render: rowData => <NavLink to="#" className={classes.tdLink} onClick={() => { props.stationDetailsTab(rowData.station_id,rowData.delete_flag) }}>{rowData.client_station_id}</NavLink>,
              headerStyle: {
                width: '10%',
              }
            },
            {
              title: 'Location', field: 'station_location', cellStyle: {
                width: '62%',
              },
              headerStyle: {
                width: '62%',
              }
            },
            {
              title: 'Type', field: 'station_type_name', cellStyle: {
                width: '15%',
              },
              // render: rowData => <div>{rowData.station_type == 1 ? 'Midblock' : 'Intersection'}</div>,
              render: rowData => <div>{rowData.station_type_name}</div>,
              headerStyle: {
                width: '15%',
              }
            }
            ,
            {
              title: 'Status', field: 'status', cellStyle: {
                width: '10%',
              },
              render: rowData => <div>{rowData.status == 'active' ? 'Active' : 'Inactive'}</div>,
              headerStyle: {
                width: '10%',
              }
            },
            {
              title: '', field: 'delete_flag', sorting: false, cellStyle: {
                width: '3%',
                textAlign: 'center',
              },
              headerStyle: {
                width: '3%',
                textAlign: 'center',
              },
              render: rowData =>
                // <p style={{ margin: '0', textAlign: 'center' }} title='Delete'><FontAwesomeIcon icon={faTimes} className={classes.deleteIcon} onClick={() => handleClickOpen(rowData.file_id, rowData.origin_name)} /></p>
                <div>{rowData.delete_flag ? <p style={{ margin: '0', textAlign: 'center' }} title='Delete'><FontAwesomeIcon icon={faTimes}
                  className={classes.deleteIcon} onClick={() => handleClickOpen(rowData.client_station_id, rowData.station_location, rowData.station_id)} /></p> : null}</div>
            }
          ]}
          data={stationList ? stationList : []}
          totalCount={totalItems}
          options={{
            thirdSortClick: false,
            filtering: false,
            search: false,
            sorting: true,
            pageSize: enteriesPerPage,
            paging: true,
            pageSizeOptions: [0],
            emptyRowsWhenPaging: false,
            maxBodyHeight: sessionStorage.getItem('dmTabWidth') >= 3501 ? (sessionStorage.getItem('dmTabHeight') - 460).toString() + 'px' : (sessionStorage.getItem('dmTabHeight') - 330).toString() + 'px'
            // maxBodyHeight: window.screen.width >= 1400 && window.screen.width <= 1500  ? '60vh' :window.screen.width >= 1550 && window.screen.width <= 1750  ? '61vh' :window.screen.width >= 1751 ? '68vh': '56vh',
          }}
          // components={
          //   userAccess == true ?
          //     {
          //       Pagination: props => (
          //         <TablePagination
          //           {...props}
          //           count={totalItems}
          //           page={pagination.selectedPage - 1}
          //           onChangePage={handleSelected}
          //           rowsPerPage={enteriesPerPage}
          //         />
          //       )
          //     } : {
          //       Pagination: props => (
          //         <TablePagination
          //           {...props}
          //           count={totalItems}
          //           page={pagination.selectedPage - 1}
          //           onChangePage={handleSelected}
          //           rowsPerPage={enteriesPerPage}
          //         />
          //       ),
          //       Body: (props) => (
          //         <tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr>
          //       )
          //     }
          // }
          components={
            userAccess == true ?
              // stationList.length > 0 ?
              getLoader == false ?
                {
                  Pagination: props => (
                    <TablePagination
                      {...props}
                      count={totalItems}
                      page={pagination.selectedPage - 1}
                      onChangePage={handleSelected}
                      rowsPerPage={enteriesPerPage}
                    />
                  ),
                }
                :
                {
                  Pagination: props => (
                    <TablePagination
                      {...props}
                      count={totalItems}
                      page={pagination.selectedPage - 1}
                      onChangePage={handleSelected}
                      rowsPerPage={enteriesPerPage}
                    />
                  ),
                  Body: (props) => (
                    <tbody><tr style={{ height: '49px' }}><td colspan="5" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress /></span> </td></tr></tbody>
                  )
                }
              : {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
                Body: (props) => (
                  <tbody><tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr></tbody>
                )
              }
          }
        />
      </div>
    </>
  )
}

export default Stations;
//Start Stations component code ...